import React, { useState, createContext } from 'react';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    menu: { position: 'relative', display: 'inline-block' },
});
export const Context = createContext([false, () => { }]);
Context.displayName = 'MenuContext';
const MenuContext = ({ children, defaultValue = false, }) => {
    const classes = useStyles();
    return (React.createElement(Context.Provider, { value: useState(defaultValue) },
        React.createElement("div", { className: classes.menu }, children)));
};
function useMenuContext() {
    const context = React.useContext(Context);
    if (context === undefined)
        throw new Error('useTabsContext must be used within a TabsContextProvider');
    return context;
}
export { MenuContext, useMenuContext };
//# sourceMappingURL=MenuContext.js.map